import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLymphNodes = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 22,
	viewBox: "0 0 56 22",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M11 0C4.93468 0 0 4.93468 0 11C0 17.0653 4.93468 22 11 22C17.0653 22 22 17.0653 22 11C22 4.93468 17.0653 0 11 0ZM11 21.2143C5.368 21.2143 0.785714 16.632 0.785714 11C0.785714 5.368 5.368 0.785714 11 0.785714C16.632 0.785714 21.2143 5.368 21.2143 11C21.2143 16.632 16.632 21.2143 11 21.2143Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M45 0C38.9347 0 34 4.93468 34 11C34 17.0653 38.9347 22 45 22C51.0653 22 56 17.0653 56 11C56 4.93468 51.0653 0 45 0ZM45 21.2143C39.368 21.2143 34.7857 16.632 34.7857 11C34.7857 5.368 39.368 0.785714 45 0.785714C50.632 0.785714 55.2143 5.368 55.2143 11C55.2143 16.632 50.632 21.2143 45 21.2143Z"
	})]
});
export default SvgLymphNodes;
